import { memo as Memo } from 'react'

//* Components
import Button from 'components/common/Button'

//* Styles
import BackButtonStyle from './style'

const BackButton = Memo(({ onClick }) => {
	return (
		<BackButtonStyle onClick={onClick}>
			<Button text='back' iconName='arrow' type='back' />
		</BackButtonStyle>
	)
})

export default BackButton
